export const FeatureFlags = {
    TN_SIGNIN_DEFAULT_ENABLED: 'tn_signin_default_enabled',
    TN_SIGNUP_DEFAULT_ENABLED: 'tn_signup_default_enabled',
    TN_MVPD_DEFAULT_ENABLED: 'tn_mvpd_default_enabled',
    TN_SIGNIN_FORGOTPASSWORD_DEFAULT_ENABLED: 'tn_signin_forgotpassword_default_enabled',
};
